import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { TranslateLoader } from '@ngx-translate/core';
import { EMPTY, Observable } from 'rxjs';
import { RawTranslation, Trads } from '@app/core/translation/models/translations.models';
import { catchError, tap, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class CustomTranslateLoaderService implements TranslateLoader {
    constructor(private http: HttpClient) {}

    getTranslation(lang: string): Observable<Trads> {
        const { tradApp, tradEnv, tradUrl } = environment.trads;

        return this.http.get<RawTranslation[]>(`${tradUrl}Translate_${tradEnv}_${lang.toUpperCase()}.json`).pipe(
            map((translations: RawTranslation[]) => this.computeTrads(translations, tradApp)),
            tap((trads) => addConsent(trads)),
            catchError((error: Error) => {
                console.error('Could not retrieve translations / trying backup for lang:' + lang, error);
                return this.getBackupTranslation(lang);
            })
        );
    }

    getBackupTranslation(lang: string): Observable<Trads> {
        const { tradApp, tradEnv, tradUrl } = environment.trads;

        return this.http.get<RawTranslation[]>(`${tradUrl}backup/Translate_${tradEnv}_${lang.toUpperCase()}.json`).pipe(
            map((translations: RawTranslation[]) => this.computeTrads(translations, tradApp)),
            tap((trads) => addConsent(trads)),
            catchError((error: Error) => {
                console.error('Could not retrieve BACKUP translations for lang:' + lang, error);
                addConsent({});
                return EMPTY;
            })
        );
    }

    computeTrads(rawTrads: RawTranslation[], app: string): Trads {
        let trads: Trads = {};

        rawTrads.forEach((rawTrad) => {
            if (rawTrad.app === 'common') {
                trads[rawTrad.trad] = rawTrad.val;
            }
        });
        rawTrads.forEach((rawTrad) => {
            if (rawTrad.app === app) {
                trads[rawTrad.trad] = rawTrad.val;
            }
        });

        return trads;
    }
}

const addConsent = (trads: Trads) => {
    localStorage.clear();
    const touCurrentDate = trads.TOU_CURRENT_DATE ? trads.TOU_CURRENT_DATE : 'AUTHORIZED';
    const gdprCurrentDate = trads.GDPR_CURRENT_DATE ? trads.GDPR_CURRENT_DATE : 'AUTHORIZED';
    localStorage.setItem('TOU_CURRENT_DATE', touCurrentDate);
    localStorage.setItem('GDPR_CURRENT_DATE', gdprCurrentDate);
};
